var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/index.ts
import axios from "axios";
import { definePathHelper, formatUrl, request, Config } from "@js-from-routes/client";
var AxiosConfig = {
  instance: axios
};
async function unwrapResponse(response, responseAs) {
  Config.withResponse(response);
  return responseAs === "response" ? response : response.data;
}
async function fetch(args) {
  const _a = args, { responseAs } = _a, options = __objRest(_a, ["responseAs"]);
  const responseType = responseAs === "response" ? void 0 : responseAs.toLowerCase();
  const config = __spreadValues({ responseType }, options);
  return AxiosConfig.instance.request(config).catch((error) => Config.onResponseError(error));
}
Object.assign(Config, { fetch, unwrapResponse });
export {
  AxiosConfig,
  Config,
  definePathHelper,
  formatUrl,
  request
};
